module.exports = __webpack_public_path__ + "static/media/IndicaDomCMY.34bdb028.png";